import privacyenTranslations from './en/privacy.json';
import cookieenTranslations from './en/cookie.json';
import privacyesTranslations from './es/privacy.json';
import cookieesTranslations from './es/cookie.json';
import privacyfrTranslations from './fr/privacy.json';
import cookiefrTranslations from './fr/cookie.json';

export const nameSpaces = ["privacy","cookie"];

export const defaultNS = 'privacy'

export const resources = {
  en: {
    privacy: privacyenTranslations,
    cookie: cookieenTranslations,
  },
  es: {
    privacy: privacyesTranslations,
    cookie: cookieesTranslations,
  },
  fr: {
    privacy: privacyfrTranslations,
    cookie: cookiefrTranslations,
  },
};

export const languages: Record<string, any> = {
  en: {nativeName: 'US'},
  es: {nativeName: 'MX'},
  fr: {nativeName: 'CA'},
};

export const fallbackLanguage = 'en';
